module.exports = __webpack_public_path__ + "static/media/fly0133.012d876b.webp";